import { createFileRoute } from '@tanstack/react-router';

import { ThemesTable } from 'component/partial/tables/themes/ThemesTable';

export const Route = createFileRoute('/n/_auth/sites/$siteId/_details/themes/')({
  component: ThemesIndexRoute,
});

function ThemesIndexRoute() {
  return <ThemesTable />;
}
